"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importStar(require("prop-types"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const intl_1 = require("@kyruus/intl");
const button_1 = require("@kyruus/button");
const provider_components_1 = require("@kyruus/provider-components");
const configUtils_1 = require("../../../lib/configUtils");
const messages_1 = __importDefault(require("../../../lib/messages"));
const AddToCalendarButton_1 = __importDefault(require("../../Header/AddToCalendarButton"));
const Tracking_1 = require("../../../lib/constants/Tracking");
const Banners_1 = require("../../Banners");
const styles_1 = require("./styles");
const SummaryCtaPortal_1 = __importDefault(require("./SummaryCtaPortal"));
const useWindowWidth_1 = __importDefault(require("../../../lib/useWindowWidth"));
const ApptDetails = ({ provider, appointment, track, selectedAppointment, apptLocation, config, featureFlags, appointmentQuery, intl, visibility, waitlistStatus }) => {
    const { aboveMd } = (0, useWindowWidth_1.default)();
    const handleClick = () => {
        track('user_action.direct_book.appointment_confirmation_page.check_in', {
            provider_id: provider.id
        });
        if (typeof window !== undefined) {
            window.location.href = appointment.previsit_url;
        }
    };
    const handlePrintClick = (e) => {
        track(Tracking_1.userEvents.PRINT);
        if (!e.isDefaultPrevented()) {
            if ((0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags)) {
                const iframe = document.createElement('iframe');
                document.body.appendChild(iframe);
                const iframeDoc = iframe.contentWindow.document;
                iframe.style.position = 'absolute';
                iframe.style.width = '0px';
                iframe.style.height = '0px';
                iframe.style.border = 'none';
                const content = document.getElementById('printable-drawer').innerHTML;
                const styles = Array.from(document.styleSheets)
                    .map((styleSheet) => {
                    try {
                        return Array.from(styleSheet.cssRules || [])
                            .map((rule) => rule.cssText)
                            .join('\n');
                    }
                    catch (e) {
                        return '';
                    }
                })
                    .join('\n');
                iframeDoc.open();
                iframeDoc.write(`
          <html>
            <head>
              <style>
                ${styles}
              </style>
            </head>
            <body>
              ${content}
            </body>
          </html>
        `);
                iframeDoc.close();
                // Trigger print and remove the iframe afterward
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
                setTimeout(() => {
                    document.body.removeChild(iframe);
                }, 1000);
                return;
            }
            const printStyles = `
        @media print {
          body {
            height: auto;
          }
        }
      `;
            const styleSheet = document.createElement('style');
            const firstStyleElementWithNonce = document.querySelector('style[nonce]');
            if (firstStyleElementWithNonce) {
                styleSheet.setAttribute('nonce', firstStyleElementWithNonce.nonce);
            }
            styleSheet.innerText = printStyles;
            document.head.appendChild(styleSheet);
            window.print();
            document.head.removeChild(styleSheet);
        }
    };
    const renderAppointmentId = (appointmentId) => {
        return (react_1.default.createElement(styles_1.StyledAppointmentIdContainer, { "data-testid": "appointment-id", id: "appointment-id" },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentId, { values: {
                    appointmentId
                } }))));
    };
    const onEventClick = (0, react_1.useCallback)((mode) => {
        track(Tracking_1.userEvents.ADD_TO_CAL, { mode });
    }, [track]);
    // Check if waitlist opt-in was successful
    const showWaitlistOptInSuccessBanner = (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enable_waitlist) && waitlistStatus && waitlistStatus.success;
    return (react_1.default.createElement(styles_1.StyledContainer, { id: "printable-drawer" },
        react_1.default.createElement(styles_1.StyledContentContainer, null,
            react_1.default.createElement(styles_1.BannerContainer, null,
                react_1.default.createElement(banner_1.default, { type: "success", icon: "check", "data-testid": "success-booking-banner" },
                    react_1.default.createElement(styles_1.StyledBannerTitle, { "data-testid": "success-booking-banner-title" },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentConfirmedTitle))),
                    react_1.default.createElement("div", { "data-testid": "success-booking-banner-description" },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.appointmentConfirmed)))),
                showWaitlistOptInSuccessBanner && react_1.default.createElement(Banners_1.WaitlistOptInSuccessBanner, null)),
            react_1.default.createElement(styles_1.StyledProviderContainerMobile, null,
                react_1.default.createElement(provider_components_1.ProviderSidebar, { appointmentQuery: appointmentQuery, locations: provider && provider.locations, selectedAppointment: selectedAppointment, provider: provider, showApptTime: true, showSchedulingHelpBanner: false }, renderAppointmentId(appointment.appointment_id))),
            react_1.default.createElement(styles_1.StyledButtonContainer, { hasPrevisitUrl: appointment.previsit_url },
                appointment.previsit_url && (react_1.default.createElement(styles_1.EarlyCheckinButton, null,
                    react_1.default.createElement(button_1.Button, { "data-testid": "ApptSummary__PreVisitCheckIn__Button", type: "button", onClick: handleClick },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.preVisitButton))))),
                react_1.default.createElement(SummaryCtaPortal_1.default, { aboveMd: aboveMd },
                    react_1.default.createElement(styles_1.PrintAndCalendarButtons, { isDrawerView: (0, configUtils_1.isDirectBookRenderedInDrawer)(config, featureFlags), aboveMd: aboveMd },
                        react_1.default.createElement(styles_1.StyledPrintButtonContainer, null,
                            react_1.default.createElement(button_1.Button, { "data-testid": "ApptSummary__Print__Button", type: "button", "aria-label": intl.formatMessage(messages_1.default.ariaPrintConfirmation), onClick: handlePrintClick },
                                react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.printButtonText)))),
                        (0, configUtils_1.shouldRenderAddToCalendarButton)(visibility) && (react_1.default.createElement(AddToCalendarButton_1.default, { track: track, provider: provider, appointment: selectedAppointment, location: apptLocation, onEventClick: onEventClick })))))),
        react_1.default.createElement(styles_1.StyledProviderContainerDesktop, null,
            react_1.default.createElement(provider_components_1.ProviderSidebar, { appointmentQuery: appointmentQuery, locations: provider && provider.locations, selectedAppointment: selectedAppointment, provider: provider, showApptTime: true, showSchedulingHelpBanner: false }, renderAppointmentId(appointment.appointment_id)))));
};
ApptDetails.propTypes = {
    provider: prop_types_1.default.object.isRequired,
    appointment: prop_types_1.default.object.isRequired,
    track: prop_types_1.default.func.isRequired,
    config: prop_types_1.default.object.isRequired,
    selectedAppointment: prop_types_1.default.func.isRequired,
    apptLocation: prop_types_1.default.object.isRequired,
    appointmentQuery: prop_types_1.default.object.isRequired,
    intl: prop_types_1.default.shape({
        formatMessage: prop_types_1.default.func.isRequired
    }).isRequired,
    visibility: prop_types_1.default.shape({
        role: prop_types_1.default.string.isRequired,
        schedulingVisibility: prop_types_1.default.string.isRequired,
        isVisibilityAgent: prop_types_1.default.bool
    }),
    featureFlags: (0, prop_types_1.shape)({
        dbw_suggest_alt_providers_for_step_1: prop_types_1.bool,
        dbw_suggest_alt_providers_for_step_2: prop_types_1.bool,
        dbw_render_in_drawer: prop_types_1.bool
    }),
    waitlistStatus: (0, prop_types_1.shape)({
        success: prop_types_1.bool
    })
};
ApptDetails.defaultProps = {
    // default values for consumer in case the visibility object is not passed
    visibility: {
        isVisibilityAgent: false,
        role: 'consumer',
        schedulingVisibility: 'consumer:direct_book'
    },
    waitlist: {
        success: false
    }
};
exports.default = (0, intl_1.injectIntl)(ApptDetails);
//# sourceMappingURL=ApptDetails.js.map